import ATableAccess from "./aTableAccess";

class MachineAccess extends ATableAccess {}

export default MachineAccess;
